import React, { Component } from "react";

import DeleteIcon from "calcite-ui-icons-react/TrashIcon";
import GearIcon from "calcite-ui-icons-react/GearIcon";

import AreaProperties from "./AreaProperties";
import AreaRolesTable from "../../base/AreaRolesTable";
import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import Rdx from "../../../redux/Rdx";
import ReservationManagers from "./ReservationManagers";
import Topic from "../../../context/Topic";
import TransactionGuard from "../../base/TransactionGuard";
import {ReactComponent as UserAdminIcon} from "./UserAdminIcon.svg";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";

import { HeaderContainer, Title, ButtonContainer } from '../../styles/Work/areaHeader';
import { queryPeopleAssignedToArea } from "../../base/officePlanUtil";
import { canDeleteDuplicate, getAttributes } from "../common/MultipleAssignments/multipleAssignmentsUtil";

export default class AreaHeader extends Component {

  useRdx = true;

  constructor(props) {
    super(props);
    this.componentId = component.nextId();
    this.state = component.newState({
      reservationManagerNames: null,
      reservationManagerFeatures: null,
      needsRoleQuery: true,
      queryingRoles: false
    });
  }

  componentDidMount() {

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, params => {
        const actions = [OfficePlan.Action_AssignmentsUpdated];
        if (actions && actions.indexOf(params.action) !== -1) {
          const plan = OfficePlan.getActive();
          if (plan && plan.hasAreaRoles()) {
            const isActive = (this.props.rdxActiveAreaId === this.getAreaId());
            if (isActive) {
              this.queryReservationManagers();
            }
          }
          component.refresh(this);
        }
      })
    ]);

  }

  componentDidUpdate(prevProps,prevState) {
    const plan = OfficePlan.getActive();
    if (!plan || !plan.hasAreaRoles()) return;
    const { rdxActiveAreaId } = this.props;
    const { prevRdxActiveAreaId } = prevProps;
    const areaId = this.getAreaId();
    const isActive = (rdxActiveAreaId === areaId);
    const wasActive = (prevRdxActiveAreaId === areaId);
    if (isActive && !wasActive) {
      if (this.state.needsRoleQuery && !this.state.queryingRoles) {
        this.queryReservationManagers();
      }
    }
    if (!isActive && wasActive && !this.state.needsRoleQuery) {
      this.setState({needsRoleQuery: true})
    }
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  deleteClicked = () => {
    const i18n = Context.instance.i18n;
    //const rdxActiveAreaKey = this.props.rdxActiveAreaKey;
    const options = {
      title: i18n.spaceplanner.areaProperties.delCaption,
      message: i18n.spaceplanner.areaProperties.delPrompt,
      okLabel: i18n.spaceplanner.areaProperties.del,
      closeOnOK: false,
      closeOnCancel: false,
    }
    ModalController.confirm(options).then(result => {
      if (result.ok) {
        result.controller.close();
        const guard = new TransactionGuard({force: true});
        const plan = Context.instance.spaceplanner.activePlan;
        const areasTable = plan && plan.areasTable;
        const areaItem = this.getAreaItem();
        const areaType = this.getAreaType()
        let duplicates = []
        queryPeopleAssignedToArea(areaItem, areaType).then(people => {
          const promises = []
          if (people && people.length > 0) {
            people.forEach(person => {
              const attributes = getAttributes(person)
              const personName = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_FULLNAME)
              const personEmail = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_EMAIL)
              const promise = canDeleteDuplicate(personName, personEmail).then(result => {
                if (result) duplicates.push(person)
              })
              promises.push(promise)
            })
          }
          return Promise.all(promises)
        }).then(() => {
          let deletePeopleData;
          if (duplicates && duplicates.length > 0) {
            deletePeopleData = duplicates;
          }
          return areasTable.deleteArea(areaItem,deletePeopleData)
        }).then(() => {
          guard.close();
          Topic.publish(Topic.PlanModified, {
            action: OfficePlan.Action_AssignmentsUpdated
          });
          const areaType = this.getAreaType();
          let rdxActiveAreaKey;
          if(areaType === "hotel") rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTEL_AREA_ID;
          else if(areaType === "hotdesk") rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
          Rdx.setValue(null, rdxActiveAreaKey, null);
          //result.controller.close();
        }).catch(error => {
          guard.close();
          //result.controller.close();
          console.error("Error updating area", error);
          Topic.publishErrorUpdatingData(error.submessage);
        });
      } else {
        result.controller.close();
      }
    });
  }

  getAreaId = () => {
    const areaItem = this.getAreaItem();
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
  }

  getAreaItem = () => {
    return this.props.areaItem;
  }

  getAreaName = () =>{
    const areaItem = this.getAreaItem();
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_NAME);
  }

  getAreaType = () => {
    return this.props.areaType;
  }

  getRdxActiveAreaKey = () => {
    return "area_id"
  }

  onChangeName = evt => {
    this.setState({ modifiedName: evt.target.value });
  }

  onReservationManagersClicked = evt => {
    ReservationManagers.showModal(
      this.state.reservationManagerFeatures,
      this.getAreaItem(),
      this.getAreaId(),
      this.getAreaName()
    );
  }

  propertiesClicked = () => {
    AreaProperties.showModal({
      caption: this.getAreaName(),
      areaItem: this.getAreaItem(),
      areaType: this.getAreaType()
    });
  }

  queryReservationManagers = () => {
    const plan = OfficePlan.getActive();
    if (plan && plan.hasAreaRoles()) {
      const areaId = this.getAreaId();
      const areaRolesTable = plan.areaRolesTable;
      const role = AreaRolesTable.ROLE_RESERVATION_MANAGER;
      const qfn = true;
      this.setState({queryingRoles: true});
      areaRolesTable.queryRoleDataByAreaId(areaId,role,qfn).then(result => {
        // console.log("queryRoleDataByAreaId.result",result)
        this.setState({
          reservationManagerNames: result && result.fullNames,
          reservationManagerFeatures: result && result.peopleFeatures,
          needsRoleQuery: false,
          queryingRoles: false
        })
      }).catch(ex => {
        this.setState({
          needsRoleQuery: false,
          queryingRoles: false
        })
        console.error("Error querying reservation managers",ex)
      })
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const areaName=this.getAreaName();
    const { rdxActiveAreaId } = this.props;
    const tooLong = areaName.length >= 30
    let tooltip = tooLong ? areaName : ""
    const truncatedAreaName = tooLong ? areaName.substring(0, 30).trim() + "..." : areaName
    const officePlan = OfficePlan.getActive();
    const isActive = (this.getAreaId() === rdxActiveAreaId);
    const isHotel = (this.props.areaType === "hotel");
    const supportsAreaRoles = isHotel && officePlan.hasAreaRoles();
    let mgrNames = this.state.reservationManagerNames;
    if (mgrNames && mgrNames.length > 0) {
      mgrNames = mgrNames.join(", ");
    } else {
      if (this.state.queryingRoles) {
        mgrNames = "...";
      } else {
        mgrNames = i18n.spaceplanner.reservationManager.noneSelected;
      }
    }

    return (
      <div style={{width: "100%"}}>
        <div>
          <HeaderContainer>
            <Title>
              <div title={tooltip}>{truncatedAreaName}</div>
            </Title>
            <ButtonContainer>
              {rdxActiveAreaId &&
                <React.Fragment>
                  <Button key="properties" clear={true}
                    title={i18n.general.properties}
                    onClick={this.propertiesClicked}
                    iconButton={true} icon={<GearIcon />} />
                  <Button key="delete" clear={true}
                    title={i18n.spaceplanner.areaProperties.del}
                    onClick={this.deleteClicked}
                    iconButton={true} icon={<DeleteIcon />} />
                </React.Fragment>
              }
            </ButtonContainer>
          </HeaderContainer>
        </div>
        {isActive && supportsAreaRoles &&
          <React.Fragment>
            <div className="i-flex-between" style={{marginTop: "16px", alignItems: "center"}}>
              <span className="i-managers-label">
                {i18n.spaceplanner.reservationManager.plural}
              </span>
              <Button
                icon={<UserAdminIcon/>}
                iconButton={true}
                title={i18n.spaceplanner.reservationManager.plural}
                onClick={this.onReservationManagersClicked}>
              </Button>
            </div>
            <div className="i-manager-names">{mgrNames}</div>
          </React.Fragment>
        }
      </div>
    );
  }

}
